import React from 'react';
import logoFull from 'assets/brand/logo.svg';

// Full wordmark — used in the expanded sidebar header.
const ExperienceFull = () => {
  return (
    <img src={logoFull} alt="Orphix" style={{ height: 28, width: 'auto', paddingLeft: "24px", display: 'block' }} />
  );
};

export default ExperienceFull;
